import { PageLoaderComponent } from './page-loader.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

@NgModule({
  declarations: [PageLoaderComponent],
  imports: [
    CommonModule, IonicModule
  ],
  exports: [PageLoaderComponent]
})
export class PageLoaderModule { }
